<div *ngIf="!canUpdateOwnership">
  Ownership can't be updated in parent entity.
</div>
<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
      *ngIf="!fieldDefinition.isHidden && canUpdateOwnership">
  <div class="flex flex-row justify-start items-start auto-flex">

  </div>
  <mat-form-field appearance="outline" class="flex-1-1-100">
    <mat-label>{{fieldDefinition.header}}</mat-label>
    <input matInput formControlName="value"
           placeholder="{{fieldDefinition.header}}"
           [errorStateMatcher]="errorMatcher"
           [readonly]="disabled"/>
    <mat-error *ngIf="inputFormError.value.required">
      {{fieldDefinition.header}} is required!
    </mat-error>
    <mat-error *ngIf="inputFormError.value.containsAlphabet">
      {{fieldDefinition.header}} should be a number.
    </mat-error>
    <mat-error *ngIf="inputFormError.value.invalidOwnership">
      {{fieldDefinition.header}} amount should be between 0 and 100.
    </mat-error>
    <mat-hint
      *ngIf='fieldDefinition.instruction && fieldDefinition.instruction.length'>{{fieldDefinition.instruction}}</mat-hint>
  </mat-form-field>

</form>
